// export const backendHost = 'http://127.0.0.1:55580'
// export const backendHost = 'https://win777.co';
export const backendHost = window.location.origin;